import { Button, Paragraph } from '@/components/atoms';
import { PageHeader } from '@/components/molecules';

interface EmptyStateProps {
  onConnect: () => void;
}

export const EmptyState = ({ onConnect }: EmptyStateProps) => {
  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        heading="Conversations"
        description="Have all your channel in one place and make sales easy"
      />

      {/* Empty State */}
      <div className="flex flex-col items-center justify-center min-h-[60vh] px-4">
        <div className="text-6xl mb-6">😔</div>
        <Paragraph className="text-gray-400 font-medium lg:text-2xl mb-20">
          You don't have any Conversation
        </Paragraph>
        <Button className="px-8 py-3 rounded-md text-base" onClick={onConnect}>
          Connect Social Channel
        </Button>
      </div>
    </div>
  );
};
